import axios from "axios";
import { nuclearn_api_url } from "src/App";
import { useMutation } from "react-query";
import { NucToast } from "src/reusable/components/Toast";
const downloadDataChunksCSV = (dataChunkIds: number[]) => {
  return axios
    .post(`${nuclearn_api_url}/chat/download-sources`, dataChunkIds, {
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Sources.csv");
      document.body.appendChild(link);
      try {
        link.click();
      } finally {
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    });
};

export const useDownloadDataChunksCSV = () => {
  return useMutation(downloadDataChunksCSV, {
    onError: (error) => {
      NucToast({
        message: `Error downloading sources: ${(error as Error).message}`,
        type: "error",
      });
    },
  });
};
